module.exports = __webpack_public_path__ + "assets/img/more.155d7381.svg";